<template>
  <div class="page">
    <van-nav-bar :title="title" />
    <van-empty description="移动端功能开发中" />
  </div>
</template>

<script>
export default {
  name: 'MobileStudentPlaceholder',

  computed: {
    title() {
      const path = this.$route.path
      if (path.includes('/practice')) return '练习'
      if (path.includes('/exam')) return '考试'
      if (path.includes('/wrong')) return '错题'
      if (path.includes('/me')) return '我的'
      return '移动端'
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #f5f7fa;
}
</style>